import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_profile_details: { message: "idle" },
};

export const retrieve_profile_details_Slice = createSlice({
 name: "retrieve_profile_details",
 initialState,
 reducers: {
  success_retrieve_profile_details: (state, action) => {
   state.retrieve_profile_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_profile_details: (state, action) => {
   state.retrieve_profile_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_profile_details: (state) => {
   state.retrieve_profile_details = { status: app_consts.IDLE };
  },
  loading_retrieve_profile_details: (state) => {
   state.retrieve_profile_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_profile_details, fail_retrieve_profile_details, reset_retrieve_profile_details, loading_retrieve_profile_details } = retrieve_profile_details_Slice.actions;

export default retrieve_profile_details_Slice.reducer;